export function resolveCollapsedPillarIds(
    allPillarIds: readonly string[],
    savedExpandedSections: string[] | undefined,
    hasSavedState: boolean,
): Set<string> {
    if (!hasSavedState) {
        return new Set(allPillarIds);
    }

    const expanded = new Set(
        (savedExpandedSections ?? []).filter((id) => allPillarIds.includes(id)),
    );

    return new Set(allPillarIds.filter((id) => !expanded.has(id)));
}

export function expandedSectionsFromCollapsed(
    allPillarIds: readonly string[],
    collapsedPillars: ReadonlySet<string>,
): string[] {
    return allPillarIds.filter((id) => !collapsedPillars.has(id));
}
